import { PaymentFormValues } from 'src/pages/payment-msi/PaymentMsiV2/PaymentMsiV2';

/**
 * Checks if the submit button should be disabled based on the provided form values.
 * @param formValues - The form values to check.
 * @returns `true` if the submit button should be disabled, `false` otherwise.
 */
export const checkIfSubmitDisabled = (formValues: PaymentFormValues) => {
  if (!formValues.agreed || !formValues.paymentData) {
    return true;
  }

  if (!formValues.billingAddress) {
    return true;
  }

  if (
    !formValues.billingAddress.addressLine1 ||
    !formValues.billingAddress.city ||
    !formValues.billingAddress.state ||
    !formValues.billingAddress.zipCode
  ) {
    return true;
  }

  return false;
};
